import { getStateFromPath } from "@react-navigation/native"
import { extra } from "../config"
import { Platform } from "react-native"

// define if build is in web or not. if so, we operate in /web
let rootPath = ''
if (Platform.OS === 'web' && extra.webappUrl.endsWith('web')) {
  rootPath = 'web'
}

export const linking = {
  prefixes: [
    // possible associated domains
    "https://impact.oneethos.com",
    "https://uat.ec.oneethos.com",
    "https://qa.ec.oneethos.com",
    // new web domains
    "https://impactbanking.oneethos.com",
    "https://uat-ib.oneethos.com",
    "https://qa-ib.oneethos.com",
    // possible custom url schemes
    "com.oneethos.impact.banking.qa://",
    "com.oneethos.impact.banking.uat://",
    "com.oneethos.impact.banking://",
    // auth0 custom url schemes
    "com.oneethos.impact.banking.qa.auth0://",
    "com.oneethos.impact.banking.uat.auth0://",
    "com.oneethos.impact.banking.auth0://",
  ],
  config: {
    path: rootPath,
    screens: {
      Login: 'login',
      BannoImpactEnvironmental: 'banno/impact/environmental/:integrationId',
      BannoImpactSocial: 'banno/impact/social/:integrationId',
      AuthRoutes: {
        path: '',
        screens: {
          App: {
            path: '',
            initialRouteName: 'DashboardStack',
            screens: {
              DashboardStack: {
                initialRouteName: 'DashboardHome',
                screens: {
                  DashboardHome: 'dashboard',
                  Company: 'dashboard/company/:id',
                  CompanySearchResults: 'dashboard/company-search'
                }
              },
              TransactionsStack: {
                path: 'transactions',
                initialRouteName: 'TransactionsHome',
                screens: {
                  TransactionsHome: '',
                  Company: 'company/:id',
                  CompanySearchResults: 'company-search'
                }
              },
              ExploreCompaniesStack: {
                path: 'explore-companies',
                initialRouteName: 'ExploreCompaniesHome',
                screens: {
                  ExploreCompaniesHome: '',
                  Company: 'company/:id',
                  CompanySearchResults: 'company-search'
                }
              },
              Settings: {
                initialRouteName: 'SettingsHome',
                screens: {
                  SettingsHome: 'settings',
                  ManageDemographics: 'settings/manage-demographics',
                  ManageAccounts: 'settings/manage-accounts',
                  ManageMfa: 'settings/manage-mfa',
                  InstitutionDetails: 'settings/institution-details',
                },
              },
            },
          },
          OnboardingStack: {
            path: 'onboarding',
            screens: {
              Welcome: 'welcome',
              Preferences: 'preferences',
              BasicInfo: 'basic-info',
              ValueSelection: 'value-selection',
              AddAccounts: 'add-accounts',
              Complete: 'complete',
            },
          },
          UnapprovedUserStack: 'waitlist',
        },
      },
      Mfa: {
        path: 'mfa',
        screens: {
          VerifyEmail: 'verify-email',
          ConfigureMfa: 'configure-mfa',
          VerifyMfa: 'verify-mfa',
          CollectName: 'collect-name',
        },
      },
      DeleteAccount: {
        path: 'delete-account',
        screens: {
          DeleteAccountHome: '',
        },
      },
    }
  },
  getStateFromPath: (
    path: string,
    config: Parameters<typeof getStateFromPath>[1]
  ): ReturnType<typeof getStateFromPath> | undefined => {
    if (path.includes('callback') || path.includes('/callback')) {
      return undefined
    }
    // if the first path in route is plaid-mobile-redirect, return undefined
    const firstSegment = path.replace(/^\/+/, '').split('/')[0]
    if (firstSegment === 'plaid-mobile-redirect') {
      return undefined
    }

    const state = getStateFromPath(path, config)

    return state
  },
}